<!--
 * @Author: your name
 * @Date: 2020-08-06 15:53:44
 * @LastEditTime: 2020-08-10 09:58:53
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \heating-wechat-web\src\components\appointment\appointmentInfo\appointmentInfo.vue
-->
<template>
  <div class="appointmentInfo-wrap">
    <div class="appointmentInfo-warp-main"  v-if="appointmentFlag">
        <div class="appointmentInfo-back"></div>
            <div class="appointmentInfo-top">
                <div style="margin-top:0.1rem">预约人姓名：{{appointmentData.userName}}</div>
                <div>预约号：{{appointmentData.idCode}}</div>
                <div>身份证号：{{appointmentData.idCardNumber}}</div>
                <div>预约时间：{{appointmentData.reservationTime}}</div>
                <div></div>
                <div class="qrcode">
                  <div class="qrcode-content">
                    <div>扫码进行预约确认</div>
                    <div><vue-qr :text="qrcodeText" backgroundColor="#fff"  qid="testid"></vue-qr></div>
                  </div>
              </div>
            </div>
    </div>
    <div class="appointmentInfo-fail" v-else>
      <div style="margin-top: 0.5rem;"><img src="../../../assets/image/recordfail.png" style="margin:0 auto;"></div>
      <div style="margin-top: 0.2rem;color:#007B83;">暂无预约信息</div>
      <div style="margin-top: 1rem;"><el-button type="primary" @click="gotoappointment">去预约</el-button></div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment';
  import VueQr from 'vue-qr';
  export default{
    name: 'appointmentInfo',
    data(){
      return{
        qrcodeText:'',// 二维码内容
        appointmentData:{},// 预约信息
        appointmentFlag:false,
      }
    },
    methods:{
      // 查看当前用户的预约信息
      async getUserAppointmentInfo(){
        const res = await this.$http.get(`${this.$url.globalurl}/wxAppointment/0`);
        if(res.result.length){
          this.appointmentFlag = true;
          const result = res.result[0];
          let name = '', code = '';
          function Loop(len,flag,str){ // 循环处理
            let result = '';
            if(flag){
              for(let i =0; i < len - 1; i++){
                result += '*';
              }
            }else{
              for(let i = 0; i < len; i++){
                result += '0';
                if(i === len - str.toString().length - 1){
                  result += str;
                  break;
                }
              }
            }
            return result;
          }
          const userName = result.reservation_name.substring(0,1) + Loop(result.reservation_name.length,true);
          const idCardNumber = result.id_card_number.substring(0,14) + Loop(5,true);
          const reservationTime = moment(result.reservation_time).format('YYYY-MM-DD HH:mm:ss');
          const idCode = Loop(6,false,result.reservation_id,2);
          this.qrcodeText = `预约号：${idCode} \n 姓名：${userName} \n 身份证：${idCardNumber} \n 预约时间:${reservationTime}`;
          this.appointmentData = {
            idCode,
            userName,
            idCardNumber,
            reservationTime
          };
        }
      },
      async gotoappointment(){
        const res = await this.$http.get(`${this.$url.globalurl}/systemConfig/${sessionStorage.getItem('customer_id')}`);
        let routerName = '';
        if(!res.result[0].reservation_status){
          routerName = 'appointment';
        }else{
          routerName = 'index';
        }
         this.$router.push({
          name: routerName
        })
      }
    },
    mounted(){
      this.getUserAppointmentInfo();
      document.title = "我的预约";
    },
    components: {
      VueQr,
    }
  }
</script>
<style scoped>
@import url(appointmentInfo.scss);
</style>